import { SVGProps } from 'react';

export const StarOutlinedIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.2802 7.06445L11.3925 7.41016H17.4813L12.8495 10.7754L12.5555 10.9893L12.6678 11.335L14.4364 16.7803L9.80457 13.415L9.51062 13.2012L9.21667 13.415L4.58386 16.7803L6.35339 11.335L6.4657 10.9893L6.17175 10.7754L1.53992 7.41016H7.62878L7.74109 7.06445L9.51062 1.61719L11.2802 7.06445Z"
        stroke="currentColor"
      />
    </svg>
  );
};
